module.exports = __webpack_public_path__ + "img/no-content.703f34e6.png";